// Imports
//=include svg4everybody/dist/svg4everybody.min.js
//=include lazysizes/lazysizes.min.js
//=include jquery/dist/jquery.min.js
//=include jquery-validation/dist/jquery.validate.min.js
//=include jquery-mask-plugin/dist/jquery.mask.min.js
//=include slick-carousel/slick/slick.min.js

svg4everybody();

function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

// DOM
var MyApp = {

    onlyNumbers: function () {
        let inputsNumber = $('.only-numbers');
        for (let counter = 0; counter < inputsNumber.length; counter++) {
            setInputFilter(inputsNumber[counter], function (value) {
                return /^[0-9]*$/.test(value);
            });
        }
    },
    onlyPhone: function () {
        let inputsPhones = $('.only-phone');
        for (let counter = 0; counter < inputsPhones.length; counter++) {
            setInputFilter(inputsPhones[counter], function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        }
    },
    onlyLetters: function () {
        let onlyletters = $('.only-letters');
        for (let counter = 0; counter < onlyletters.length; counter++) {
            setInputFilter(onlyletters[counter], function (value) {
                return /^[a-zA-ZñÑáéíóúÁÉÍÓÚ'´äëïöüÄËÏÖÜ.àèìòùÀÈÌÒÙâêîôûÂÊÎÔÛ \-]*$/.test(value);
            });
        }
    },
    onlyAlphaNumeric: function () {
        let onlyAlphaNumerics = $('.only-alpha-numeric');
        for (let counter = 0; counter < onlyAlphaNumerics.length; counter++) {
            setInputFilter(onlyAlphaNumerics[counter], function (value) {
                return /^[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ'´äëïöüÄËÏÖÜ.àèìòùÀÈÌÒÙâêîôûÂÊÎÔÛ \-]*$/.test(value);
            });
        }
    }, 
    onlyDate: function () {

        let onlyDate = $('.only-date');

        for (let counter = 0; counter < onlyDate.length; counter++) {
            setInputFilter(onlyDate[counter], function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        }

        onlyDate.mask('99/99/0000');
    },
    onlyTime: function () {

        let onlyTime = $('.only-time');

        for (let counter = 0; counter < onlyTime.length; counter++) {
            setInputFilter(onlyTime[counter], function (value) {
                return /^[0-9aApPmM\: ]*$/.test(value);
            });
        }

        onlyTime.mask('00:00 AA');
    },
    modalMessage:  {
        openModal: function () {
            var date = new Date();
            var month = date.getMonth();
            var day = date.getDate();
            var hour = date.getHours();
            if (month == 4) {
                if (day == 28 && hour >= 8) {
                    $('.modal-message').show();
                    $('.modal-message__content--memorial').show();
                    $('.modal-message__close').attr('tabindex', 1);
                } else if (day > 28 && day < 31) {
                    $('.modal-message').show();
                    $('.modal-message__content--memorial').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
                if (day == 31 && hour < 22) {
                    $('.modal-message').show();
                    $('.modal-message__content--memorial').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
            }
            else if (month == 11) {
                if (day == 24 && hour >= 8) {
                    $('.modal-message').show();
                    $('.modal-message__content--christmas').show();
                    $('.modal-message__close').attr('tabindex', 1);
                } else if (day > 24 && day < 28) {
                    $('.modal-message').show();
                    $('.modal-message__content--christmas').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
                if (day == 28 && hour < 8) {
                    $('.modal-message').show();
                    $('.modal-message__content--christmas').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
                if (day == 31 && hour >= 8) {
                    $('.modal-message').show();
                    $('.modal-message__content--new-year').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
            }
            else if (month == 0) {
                if (day == 1 && hour >= 0) {
                    $('.modal-message').show();
                    $('.modal-message__content--new-year').show();
                    $('.modal-message__close').attr('tabindex', 1);
                } else if (day > 1 && day < 4) {
                    $('.modal-message').show();
                    $('.modal-message__content--new-year').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
                if (day == 4 && hour < 8) {
                    $('.modal-message').show();
                    $('.modal-message__content--new-year').show();
                    $('.modal-message__close').attr('tabindex', 1);
                }
            }
        },
        closeModal: function () {
            $('.modal-message__close').click(function (event) {
                $('.modal-message').hide();
            });
        }
    },
    login : {
        form : function () {
            $('.login-form').validate({
                errorClass: 'login-form__error',
                messages: {
                    username: {
                        required: 'Please enter your username'
                    },
                    password: {
                        required: 'Please enter your password'
                    }
                },
                submitHandler: function (form) {
                    $(form).addClass('is-loading');
                    $(form).find('button[class*="submit"]').prop('disabled', true);
                    form.submit();
                }
            });
        },
        phone : function () {
            $('#phone').mask('000-000-0000');
        }
    },
    messages : {
        closeMessage: function () {
            $('.js-hero-message__close').click(function (event) {
                event.preventDefault();
                $(this).closest('.hero-message').slideUp();
            });
        }
    },
    overlay : {
        showOverlay : function () {
            $('.js-modals__overlay').stop().fadeIn();
        },
        hideOverlay : function () {
            $('.js-modals__overlay').stop().fadeOut();
        }
    },
    search : {
        form : function () {
            $('.js-search-widget').each(function () {
                $(this).validate({
                    errorPlacement: function () { },
                    highlight: function (element) {
                        $(element).closest('.js-search-widget').addClass('js-search-widget_error');
                    },
                    unhighlight: function (element) {
                        $(element).closest('.js-search-widget').removeClass('js-search-widget_error');
                    },
                    errorClass: 'js-search-widget__error',
                    submitHandler: function (form) {
                        $(form).addClass('is-loading');
                        $(form).find('button[class*="submit"]').prop('disabled', true);
                        form.submit();
                    }
                });
            });
        }
    },
    modals: {
        openModalHeader : function () {
            $('.js-site-header-modal-button').click(function (event) {
                event.preventDefault();
                var target = $(this).data('target');
                var modal = '#'+target;
                $(modal).stop().fadeIn();
                MyApp.overlay.showOverlay();
            });
        },
        closeModal : function () {
            $('.js-modals-box__close').click(function (event) {
                event.preventDefault();
                $(this).closest('.modals-box').stop().fadeOut();
                MyApp.overlay.hideOverlay();
            });
        }
    },
    header : {
        headerCollapse: function () {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();

                if (scroll >= 120) {
                    $('.site-header').addClass('site-header_collapsed');
                } else {
                    $('.site-header').removeClass('site-header_collapsed');
                }
            });
        }
    },
    menu : {
        openMenu : function () {
            $('.js-site-header-controls__button_menu').click(function (event) {
                event.preventDefault();
                $('.site-header-menu').addClass('site-header-menu_active');
                $('.site-header__overlay').stop().fadeIn();
            });
        },
        closeMenu : function () {
            $('.js-site-header-menu__close').click(function (event) {
                event.preventDefault();
                $('.site-header-menu').removeClass('site-header-menu_active');
                $('.site-header__overlay').stop().fadeOut();
            });
        },
        openSubmenu: function () {
            $('.js-site-header-menu__link[href="#"]').click(function (event) {
                event.preventDefault();
                var targetSubmenu = $(this).next('.js-site-header-submenu__list');
                if ($(this).hasClass('js-site-header-menu__link_active')) {
                    $(this).removeClass('js-site-header-menu__link_active');
                    $(this).next('.js-site-header-submenu__list').stop().slideUp();
                } else {
                    $('.js-site-header-menu__link[href="#"]').removeClass('js-site-header-menu__link_active');
                    $(this).addClass('js-site-header-menu__link_active');
                    $('.js-site-header-submenu__list').not(targetSubmenu).stop().slideUp();
                    $(this).next('.js-site-header-submenu__list').stop().slideDown();
                }
            });
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.js-site-header-menu').length) {
                    $('.js-site-header-menu__link[href="#"]').removeClass('js-site-header-menu__link_active');
                    $('.js-site-header-submenu__list').stop().slideUp()
                }
            });
        }
    },
    home: {
        /*heroSlider : function () {
            $('.js-home-hero-slider__list').slick({
                prevArrow: $('.home-hero-slider__prev'),
                nextArrow: $('.home-hero-slider__next'),
            });
        },*/
        hideQuickLinks: function () {
            $('.home-hero-slider__content').stop().fadeIn();
            $('.js-home-hero-links__link').removeClass('home-hero-links__link_active');
            $('.home-hero-quick-links').stop().fadeOut();
            $('.home-hero-quick-links-box').stop().fadeOut();
        },
        closeQuickLinks: function () {
            $('.js-home-hero-quick-links__close').click(function (event) {
                event.preventDefault();
                MyApp.home.hideQuickLinks();
            });
        },
        openQuickLinks : function () {
            $('.js-home-hero-links__link').stop().click(function (event) {
                event.preventDefault();
                var quickLinkHref = $(this).attr('href');
                if ($(this).hasClass('home-hero-links__link_active')) {
                    MyApp.home.hideQuickLinks();         
                } else {
                    $('.home-hero-slider__content').stop().fadeOut();
                    $('.js-home-hero-links__link').removeClass('home-hero-links__link_active');
                    $(this).addClass('home-hero-links__link_active');
                    $('.home-hero-quick-links').stop().fadeIn();
                    $('.home-hero-quick-links-box').stop().fadeOut().promise().done(function () {
                        $(quickLinkHref).stop().fadeIn();
                    });
                }
            });
        },
        readMoreFeatures : function () {
            $('.js-home-features-section__read-more a').click(function (event) {
                event.preventDefault();
                this.expand = !this.expand;
                $('.text-read').text(this.expand?"Read less":"Read more");
                $(this).closest('.home-features-section__read-more').prev('.home-features-section__droppable').stop().slideToggle();
            });
        }
    },
    lazyVideo : {
        videoThumbnail : function () {
            var video = $('.lazy-video');
            $('.lazy-video').each(function () {
                var image = new Image();
                var imageSource = 'https://img.youtube.com/vi/' + $(this).data('embed') + '/sddefault.jpg';
                $(image).attr({
                    src : imageSource
                });
                $(this).append(image);
            });
        },
        loadVideo : function () {
            $('.lazy-video').each(function (){
                $(this).on('click', function () {
                    var iframe = document.createElement('iframe');
                    var iframeSource = 'https://www.youtube.com/embed/' + $(this).data('embed') + '?rel=0&showinfo=0&autoplay=1';
                    $(iframe).attr({
                        src: iframeSource,
                        border: 0
                    });
                    $(this).html('').append(iframe);
                });
            });
        }
    },
    faqs : {
        faqsCollapsable : function () {
            $('.js-faqs__question').click(function (event) {
                event.preventDefault();
                $(this).toggleClass('faqs__question_active').next('.faqs__answer').stop().slideToggle();
            });
        }
    },
    team : {
        teamSlideToggle : function () {
            $('.js-page-team-toggle').click(function (event) {
                event.preventDefault(); 
                var current = $(this);
                if ($(this).hasClass('page-team-toggle_active')) {
                    $(this).removeClass('page-team-toggle_active').next('.page-team-toggable').slideUp();
                } else {
                    $('.js-page-team-toggle').removeClass('page-team-toggle_active');
                    $('.page-team-toggable').stop().slideUp().promise().done(function () {
                        current.addClass('page-team-toggle_active').next('.page-team-toggable').stop().slideDown().promise().done(function () {
                            $('html,body').animate({
                                scrollTop: current.offset().top - 80
                            }, 'fast');
                        });
                    });
                    
                }
            });
            $('.js-page-team-controls__link').click(function (event) {
                event.preventDefault();
                var target = $(this).attr('href');
                if (!$(this).hasClass('page-team-controls__link_active')) {
                    $('.js-page-team-controls__link').removeClass('page-team-controls__link_active');
                    $(this).addClass('page-team-controls__link_active');
                    $('.page-team-toggable').stop().fadeOut().promise().done(function () {
                        $(target).fadeIn();
                    });
                }
            });
        }
    },
    contact : {
        form: function () {
            $.validator.methods.email = function (value, element) {
                return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
            }

            $('.js-contact-form').validate({
                errorClass: 'js-contact-form__error',
                rules: {
                    name: { minlength: 2 },
                    email: { minlength: 3, maxlength: 255 },
                    message: { minlength: 3 },
                    step1_email: { minlength: 3, maxlength: 255 },
                    step1_email_insured_party: { minlength: 3, maxlength: 255 },
                    step2_passenger_email: { minlength: 3, maxlength: 255 },
                    step2_passenger2_email: { minlength: 3, maxlength: 255 },
                    step2_adjuster_email: { minlength: 3, maxlength: 255 },
                    step2_property_email: { minlength: 3, maxlength: 255 },
                    step3_involved_email: { minlength: 3, maxlength: 255 },
                    telephone: { minlength: 12, maxlength: 12 },
                    'zipcode[]': {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.freewaylms.com/controller/validation-zipcode.php?',
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    }
                },
                messages: {
                    name: {
                        required: 'Please enter your name'
                    },
                    purpose: {
                        required: 'Please select a purpose'
                    },
                    email: {
                        required: 'Please enter your email'
                    },
                    step1_email: {
                        required: 'Please enter your email'
                    },
                    step1_email_insured_party: {
                        required: 'Please enter your email'
                    },
                    step2_passenger_email: {
                        required: 'Please enter your email'
                    },
                    step2_passenger2_email: {
                        required: 'Please enter your email'
                    },
                    step2_adjuster_email: {
                        required: 'Please enter your email'
                    },
                    step2_property_email: {
                        required: 'Please enter your email'
                    },
                    step3_involved_email: {
                        required: 'Please enter your email'
                    },
                    telephone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    }
                },
                submitHandler: function (form) {
                    $(form).addClass('is-loading');
                    $(form).find('button[class*="submit"]').prop('disabled', true);
                    form.submit();
                }
            });

            $('.page-agents-form__radio-input').change(function () {
                var val = $(this).val();
                if (val == 'yes') {
                    $(this).closest('.page-agents-form__item').next('.page-agents-form__droppable').slideDown();
                } else {
                    $(this).closest('.page-agents-form__item').next('.page-agents-form__droppable').slideUp();
                }
                console.log(val);
            });
        },
        phone: function () {
            $('.phone-mask').mask('000-000-0000');
        }
    },
    claims: {
        dependand: function () {
            let dependadInputs = $('[data-dependand]');
            dependadInputs.on('keyup', function () {
                let dataDependadGroupVal = $(this).attr('data-dependand');
                let dataDependadGroup = $('[data-dependand=' + dataDependadGroupVal + ']')
                if ($(this).val().trim() != '') {
                    console.log($(this).val());
                    dataDependadGroup.prop('required', true);
                } else {
                    let emptyInputs = dataDependadGroup.filter(function () {
                        return $(this).val().trim() === '';
                    });
                    if (emptyInputs.length === dataDependadGroup.length) {

                        dataDependadGroup.prop('required', false);
                        dataDependadGroup.valid();
                    }
                }
            });
        },
        file : function () {
            var inputsFile = document.querySelectorAll('.claims-form__file-button');
            Array.prototype.forEach.call(inputsFile, function (input) {
                let label = input.nextElementSibling,
                    labelVal = label.innerHTML;

                input.addEventListener('change', function (e) {
                    let fileName = '';
                    if (this.files && this.files.length > 1) {
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    } else {
                        fileName = e.target.value.split('\\').pop();
                        //this.nextElementSibling.classList.remove('button-add-files_active');
                    }
		            if (fileName) {
                        label.querySelector('span').innerHTML = fileName;
                        this.nextElementSibling.classList.add('button-add-files_active');
                    } else {
                        label.innerHTML = labelVal;
                        this.nextElementSibling.classList.remove('button-add-files_active');
                    }
                });
            });

            var clearFiles = document.querySelectorAll('.button-clear-files');
            Array.prototype.forEach.call(clearFiles, function (elem) {
                let label = elem.previousSibling.previousSibling,
                    labelVal = label.innerHTML;
                elem.addEventListener('click', function (e) {
                    this.previousElementSibling.previousElementSibling.value = '';
                    this.previousSibling.previousSibling.innerHTML = labelVal ;
                    this.previousSibling.previousSibling.classList.remove('button-add-files_active');
                });
            });
        },
        form: function () {
            jQuery.validator.addMethod('lessThanCurrentDate', function (value, element) {
                var splitUserDOB = value.split('/');
                var DOB = new Date(splitUserDOB[2] + '/' + splitUserDOB[0] + '/' + splitUserDOB[1]);
                var currentDate = new Date();

                if (DOB >= currentDate) {
                    return this.optional(element) || false;
                } else {
                    return true;
                }
            }, 'Please enter a valid date.');

            jQuery.validator.addMethod('date', function (value, element) {
                return this.optional(element) || /^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}$/.test(value);
            }, 'Please enter a valid date.');

            jQuery.validator.addMethod('year', function (value, element) {
                return this.optional(element) || /^(19|20)[0-9]{2}$/.test(value);
            }, 'Please enter a valid year.');

            jQuery.validator.addMethod('yearLessThanCurrent', function (value, element) {
                if (value <= new Date().getFullYear() + 1) {
                    return true
                } 
            }, 'Please enter a valid year.');

            jQuery.validator.addMethod('time', function (value, element) {
                return this.optional(element) || /^((0?[1-9])|1[012])\:(([0-5][0-9])|([0-9])) ((A|P|a|p)(m|M))$/.test(value);
            }, 'Please enter a valid time.');

            $.validator.methods.email = function (value, element) {
                return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
            }

            $('.claims-form').validate({
                errorClass: 'claims-form__error',
                rules: {
                    name: { minlength: 2 },
                    purpose: { minlength: 2 },
                    email: { minlength: 3, maxlength: 255 },
                    telephone: { minlength: 12, maxlength: 12 },
                    step1_phone: { minlength: 12, maxlength: 12 },
                    step1_office_phone: { minlength: 12, maxlength: 12 },
                    step1_cell_phone: { minlength: 12, maxlength: 12 },
                    step1_home_phone_insured_party: { minlength: 12, maxlength: 12 },
                    step1_office_phone_insured_party: { minlength: 12, maxlength: 12 },
                    step1_cell_phone_insured_party: { minlength: 12, maxlength: 12 },
                    step2_passenger_phone: { minlength: 12, maxlength: 12 },
                    step2_passenger2_phone: { minlength: 12, maxlength: 12 },
                    step2_adjuster_phone: { minlength: 12, maxlength: 12 },
                    step2_property_phone: { minlength: 12, maxlength: 12 },
                    step3_involved_phone: { minlength: 12, maxlength: 12 },
                    step3_involved_primary: { minlength: 12, maxlength: 12 },
                    step4_witness_home_phone: { minlength: 12, maxlength: 12 },
                    step4_witness_office_phone: { minlength: 12, maxlength: 12 },
                    step4_witness_cell_phone: { minlength: 12, maxlength: 12 },
                    step1_email: { minlength: 3, maxlength: 255 },
                    step1_email_insured_party: { minlength: 3, maxlength: 255 },
                    step2_passenger_email: { minlength: 3, maxlength: 255 },
                    step2_passenger2_email: { minlength: 3, maxlength: 255 },
                    step2_adjuster_email: { minlength: 3, maxlength: 255 },
                    step2_property_email: { minlength: 3, maxlength: 255 },
                    step3_involved_email: { minlength: 3, maxlength: 255 },
                    zipcode: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },                    
                    step1_zip_code: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    step1_zipcode_reported_by: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcode_detalle2').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    step1_zipcode_insured_party: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcodeInsuredParty').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    step2_policy_holder_zipcode: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#policyHolderZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    step2_other_vehicle_zipcode: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#otherVehicleZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    step3_involved_zipcode: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#involvedZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                    },
                    incidentDate : {
                        date: true,
                        lessThanCurrentDate: true
                    },
                    step3_involved_birthdate : {
                        date: true,
                        lessThanCurrentDate: true
                    },
                    step1_incident_date : {
                        date: true,
                        lessThanCurrentDate: true
                    },
                    step2_vehicle_year : {
                        year: true
                    },
                    step2_other_vehicle_year : {
                        year: true
                    },
                    incidentTitme : {
                        time: true
                    },
                    step1_incident_titme : {
                        time: true
                    },
                    reportedDate: {
                        date: true
                    },
                    reportedTime: {
                        time: true
                    },
                    vehicleYear: {
                        year: true,
                        yearLessThanCurrent: true
                    },
                    otherVehicleYear: {
                        year: true,
                        yearLessThanCurrent: true
                    }
                },
                messages: {
                    name: {
                        required: 'Please enter your name'
                    },
                    purpose: {
                        required: 'Please enter your purpose'
                    },
                    email: {
                        required: 'Please enter your email'
                    },
                    telephone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_office_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_cell_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_home_phone_insured_party: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_office_phone_insured_party: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_cell_phone_insured_party: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step2_passenger_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step2_passenger2_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step2_adjuster_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step2_property_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step3_involved_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step3_involved_primary: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step4_witness_home_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step4_witness_office_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step4_witness_cell_phone: {
                        minlength: 'You must enter 10 digits',
                        maxlength: 'You must enter 10 digits',
                        required: 'Please enter your telephone number'
                    },
                    step1_email: {
                        required: 'Please enter your email'
                    },
                    step1_email_insured_party: {
                        required: 'Please enter your email'
                    },
                    step2_passenger_email: {
                        required: 'Please enter your email'
                    },
                    step2_passenger2_email: {
                        required: 'Please enter your email'
                    },
                    step2_adjuster_email: {
                        required: 'Please enter your email'
                    },
                    step2_property_email: {
                        required: 'Please enter your email'
                    },
                    step3_involved_email: {
                        required: 'Please enter your email'
                    }
                },
                submitHandler: function (form) {
                    $(form).addClass('is-loading');
                    $(form).find('button[class*="submit"]').prop('disabled', true);
                    form.submit();
                }
            });
            if ($('#policyNumber').length) {
                 $('#policyNumber').rules('add', {
                    minlength: 3,
                    maxlength: 25,
                    required: true
                });
            }

            if ($('#incidentDate').length) {
                $('#incidentDate').rules('add', {
                    date: true
                });
            }
            if ($('#incidentTitme').length) {
                $('#incidentTitme').rules('add', {
                    time: true
                });
            }
            if ($('#reportedDate').length) {
                $('#reportedDate').rules('add', {
                    date: true
                });
            }
            if ($('#reportedTime').length) {
                $('#reportedTime').rules('add', {
                    time: true
                });
            }
            if ($('#vehicleYear').length) {
                $('#vehicleYear').rules('add', {
                    year: true,
                    yearLessThanCurrent: true
                });
            }
            if ($('#otherVehicleYear').length) {
                $('#otherVehicleYear').rules('add', {
                    year: true,
                    yearLessThanCurrent: true
                });
            }
            if ($('#zipcode').length) {
                $('#zipcode').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
            if ($('#zipcodeReportedBy').length) {
                $('#zipcodeReportedBy').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcodeReportedBy').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
            if ($('#zipcodeInsuredParty').length) {
                $('#zipcodeInsuredParty').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#zipcodeInsuredParty').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
            if ($('#policyHolderZipcode').length) {
                $('#policyHolderZipcode').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#policyHolderZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
            if ($('#otherVehicleZipcode').length) {
                $('#otherVehicleZipcode').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#otherVehicleZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
            if ($('#involvedZipcode').length) {
                $('#involvedZipcode').rules('add', {
                    digits: true,
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript',
                            data: {
                                zipcode: function () { return $('#involvedZipcode').val(); }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code"';
                            }
                        }
                });
            }
        },
        addPassenger1 : function () {
            var passengers1ItemClone = $('.claims-form__item_passengers1 .claims-form__subitem');
            $('[name=addPassenger1]').on('change', function () {
                if (this.value=='Yes') {
                    if ($('.claims-form__item_passengers1 .claims-form__subitem').length == 0) {
                        $('.claims-form__item_passengers1 .claims-form__subitems').prepend(passengers1ItemClone);
                    }
                    $(this).closest('.claims-form__item').next('.claims-form__item_passengers1').slideDown();
                } else {
                    $(this).closest('.claims-form__item').next('.claims-form__item_passengers1').slideUp();
                }
            });

            $('.claims-form__item_passengers1').on('click', '.claims-form__delete-subitem', function () {
                $(this).closest('.claims-form__subitem').remove();
                $('.claims-form__item_passengers1 .claims-form__subitem').each(function (index) {
                    $(this).find('.passengers1-number').html(index + 1);
                    $('.claims-form__item_passengers1 .claims-form__subitem').each(function (index) {
                        $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                    })
                })
                if ($('.claims-form__item_passengers1 .claims-form__subitem').length == 0) {
                    $('[name=addPassenger1]').prop('checked', true);
                    $('.claims-form__item_passengers1').slideUp();
                }
            })

            $('.claims-form__item_passengers1').on('click', '.claims-form__add-passengers1-button', function () {
                var passengers1ItemCount = $('.claims-form__item_passengers1 .claims-form__subitem').length;
                var passengers1ItemCloned = passengers1ItemClone.clone();
                passengers1ItemCloned.find('.passengers1-number').html(passengers1ItemCount +1);
                $('.claims-form__item_passengers1 .claims-form__subitems').append(passengers1ItemCloned);
                $('.claims-form__item_passengers1 .claims-form__subitem').each(function (index) {
                    $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                })

            });
        },
        addPassenger2 : function () {
            var passengers2ItemClone = $('.claims-form__item_passengers2 .claims-form__subitem');
            $('[name=addPassenger2]').on('change', function () {
                if (this.value=='Yes') {
                    if ($('.claims-form__item_passengers2 .claims-form__subitem').length == 0) {
                        $('.claims-form__item_passengers2 .claims-form__subitems').prepend(passengers2ItemClone);
                    }
                    $(this).closest('.claims-form__item').next('.claims-form__item_passengers2').slideDown();
                } else {
                    $(this).closest('.claims-form__item').next('.claims-form__item_passengers2').slideUp();
                }
            });

            $('.claims-form__item_passengers2').on('click', '.claims-form__delete-subitem', function () {
                $(this).closest('.claims-form__subitem').remove();
                $('.claims-form__item_passengers2 .claims-form__subitem').each(function (index) {
                    $(this).find('.passengers2-number').html(index + 1);
                    $('.claims-form__item_passengers2 .claims-form__subitem').each(function (index) {
                        $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                    })
                })
                if ($('.claims-form__item_passengers2 .claims-form__subitem').length == 0) {
                    $('[name=addPassenger2]').prop('checked', true);
                    $('.claims-form__item_passengers2').slideUp();
                }
            })

            $('.claims-form__item_passengers2').on('click', '.claims-form__add-passengers2-button', function () {
                var passengers2ItemCount = $('.claims-form__item_passengers2 .claims-form__subitem').length;
                var passengers2ItemCloned = passengers2ItemClone.clone();
                passengers2ItemCloned.find('.passengers2-number').html(passengers2ItemCount +1);
                $('.claims-form__item_passengers2 .claims-form__subitems').append(passengers2ItemCloned);
                $('.claims-form__item_passengers2 .claims-form__subitem').each(function (index) {
                    $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                })

            });
        },
        property : function () {
            var propertyItemClone = $('.claims-form__item_property .claims-form__subitem');
            $('[name=addProperty]').on('change', function () {
                if (this.value=='Yes') {
                    if ($('.claims-form__item_property .claims-form__subitem').length == 0) {
                        $('.claims-form__item_property .claims-form__subitems').prepend(propertyItemClone);
                    }
                    $(this).closest('.claims-form__item').next('.claims-form__item_property').slideDown();
                } else {
                    $(this).closest('.claims-form__item').next('.claims-form__item_property').slideUp();
                }
            });

            $('.claims-form__item_property').on('click', '.claims-form__delete-subitem', function () {
                $(this).closest('.claims-form__subitem').remove();
                $('.claims-form__item_property .claims-form__subitem').each(function (index) {
                    $(this).find('.property-number').html(index + 1);
                    $('.claims-form__item_property .claims-form__subitem').each(function (index) {
                        $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                        $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                    })
                })
                if ($('.claims-form__item_property .claims-form__subitem').length == 0) {
                    $('[name=addProperty]').prop('checked', true);
                    $('.claims-form__item_property').slideUp();
                }
            })

            $('.claims-form__item_property').on('click', '.claims-form__add-property-button', function () {
                var propertyItemCount = $('.claims-form__item_property .claims-form__subitem').length;
                var propertyItemCloned = propertyItemClone.clone();
                propertyItemCloned.find('.property-number').html(propertyItemCount +1);
                $('.claims-form__item_property .claims-form__subitems').append(propertyItemCloned);
                $('.claims-form__item_property .claims-form__subitem').each(function (index) {
                    $(this).find('.claims-form__label').attr('for', $(this).find('.claims-form__label').attr('for').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('id', $(this).find('.claims-form__input').attr('id').split('_')[0] + '_' + (index + 1));
                    $(this).find('.claims-form__input').attr('name', $(this).find('.claims-form__input').attr('name').split('_')[0] + '_' + (index + 1));
                })

            });
        }
    },
    insurance : {
        testimoniesSlider : function () {
            $('.js-page-testimonies-slider').slick({
                dots: true,
                prevArrow: $('.page-testimonies-slider__prev'),
                nextArrow: $('.page-testimonies-slider__next'),
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            dots: false,
                            slidesToShow: 2
                        }
                    }
                ]
            });
        },
        stateSelect : function () {
            $('.js-page-states__select').change(function () {
                var state = $(this).val();
                $('.js-page-states-content__box').stop().fadeOut().promise().done(function () {
                    $('.js-page-states-content__box[data-state="'+state+'"]').fadeIn();
                });
            });
        },
        stateDroppable : function () {
            $('.js-page-states-content__drop-button').click(function (event) {
                event.preventDefault();
                if (!$(this).hasClass('page-states-content__drop-button_active')) {
                    $('.js-page-states-content__drop-button').removeClass('page-states-content__drop-button_active');
                    $('.page-states-content__droppable').slideUp();
                    $(this).addClass('page-states-content__drop-button_active').next('.page-states-content__droppable').slideDown();
                } else {
                    $(this).removeClass('page-states-content__drop-button_active').next('.page-states-content__droppable').slideUp();
                }
            });
        },
        selectStateMap : function () {
            $('.map-state').click(function (event) {
                event.preventDefault();
                $('.map-state').removeClass('map-state_active');
                $(this).addClass('map-state_active');
                var state = $(this).data('state');
                $('.js-page-states-content__box').stop().fadeOut().promise().done(function () {
                    $('.js-page-states-content__box[data-state="' + state + '"]').fadeIn();
                });
            });
        }
    },
    knowledgeCenter: {
        suscribeForm: function () {

            $('.js-kc-suscribe__form').validate({
                errorClass: 'kc-suscribe__error',
                rules: {
                    email: { minlength: 3, maxlength: 255 }
                },
                messages: {
                    email: {
                        required: 'Please enter your email'
                    }
                }
            });
        }
    },
    article: {
        suscribeForm: function () {

            $('.js-article-suscribe-form').validate({
                errorClass: 'article-suscribe-form__error',
                rules: {
                    email: { minlength: 3, maxlength: 255 }
                },
                messages: {
                    email: {
                        required: 'Please enter your email'
                    }
                }
            });
        }
    },
    table: {
        responsiveTable : function () {
            var arrayTh = [];
            $('.table thead th').each(function () {
                arrayTh.push($(this).text());
            });
            $('.table tbody tr').each(function () {
                var td= $(this).find('td');
                $.each(arrayTh, function (key, value) {
                    $(td[key]).attr('data-content', value);
                });
            });
        }
    },
    locations: {
        locationForm: function(){
            $('.js-location-form').validate({
                errorClass: 'js-location-form__error',
                rules: {
                    address: {
                        digits: true,
                        minlength: 3,
                        maxlength: 5
                    }
                },
                messages: {
                    address: {
                        required: 'Zip Code is required'
                    }
                }
            });
            
        }
    },
    office: {
        testimonials: function () {
            $('.office__testimonial-slick').slick({
                dots: false,
                prevArrow: '<button class="slick-prev" type="button">prev</button>',
                nextArrow: '<button class="slick-next" type="button">next</button>',
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            prevArrow: false,
                            nextArrow: false,
                            dots: true
                        }
                    }
                ]
            });
        }
    },
    dymanicTabs: {
        showTab: function () {
            $('.tabs__content > div').hide();
            $('.tabs__content > div:first-of-type').fadeIn();
            $('.tabLink').click(function(e){
                e.preventDefault();
                var $this = $(this),
                    tabgroup = '#'+$this.parents('.tabsGroup').data('tabgroup'),
                    others = $this.closest('li').siblings().children('a'),
                    target = $this.attr('href');
                others.removeClass('active');
                $this.addClass('active');
                $(tabgroup).children('div').hide();
                $(target).fadeIn();
            });
        }
    },
    officeProfile: {
        officeProForm: function(){
            jQuery.validator.setDefaults({
                debug: true,
                success: "valid"
            });
            var form = $(".js-office-form");
            form.validate({
                errorElement:'span',
                errorClass: 'js-office-form__error',
                rules:{
                    from: {minlength:2},
                    office: {minlength:2}
                },
                messages: {
                    from: {
                        required: 'From is required'
                    },
                    office: {
                        required: 'Office Address is required'
                    }
                },
                submitHandler: function(form, event) {
                    event.preventDefault();
                }
            });
            $(".office__directions__form-button").click(function() {
                form.valid();
            });
        }
    },
    checkWebp: function () {
        Modernizr.on('webp', function (result) {
            if (!result) {
                $('[data-nowebp]').each(function () {
                    var noWebpUrl = $(this).data('nowebp');
                    $(this).css('background-image', noWebpUrl);
                })
            }
        });
    },
    onPageShow: {
        buttonDisabled: function () {
            $(window).on('pageshow', function () {
                let submitButtonDisabled = $('button[class*="submit"]');
                if (submitButtonDisabled.length) {
                    submitButtonDisabled.prop('disabled', false);
                }
            });
        }
    }
}
const siteHeader = $('.site-header');
let urlPage = window.location.href;
if (urlPage.split('#')[1]) {
    let idLinkPage = $('#' + $.escapeSelector(urlPage.split('#')[1]));

    $(window).on('load', function () {
        $('html, body').animate({
            scrollTop: idLinkPage.offset().top - siteHeader.outerHeight()
        });
    });
}

// On ready

$(function () {

    MyApp.header.headerCollapse();

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }

    if ($('.only-phone').length) {
        MyApp.onlyPhone();
    }

    if ($('[data-noWebp]').length) {
        MyApp.checkWebp();
    }

    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }

    if ($('.only-date').length) {
        MyApp.onlyDate();
    }

    if ($('.only-time').length) {
        MyApp.onlyTime();
    }

    if ($('.only-alpha-numeric').length) {
        MyApp.onlyAlphaNumeric();
    }

    if ($('.hero-message').length) {
        MyApp.messages.closeMessage();
    }

    if ($('.login-form').length) {
        MyApp.login.form();
        MyApp.login.phone();
    }

    if ($('.modal-message').length) {
        MyApp.modalMessage.openModal();
        MyApp.modalMessage.closeModal();
    }

    if ($('.lazy-video').length) {
        MyApp.lazyVideo.videoThumbnail();
        MyApp.lazyVideo.loadVideo();
    }

    if ($('.modals').length) {
        MyApp.modals.closeModal();
        MyApp.modals.openModalHeader();
    }

    if ($('.js-search-widget').length) {
        MyApp.search.form();
    }

    if ($('.site-header__menu').length) {
        MyApp.menu.openMenu();
        MyApp.menu.closeMenu();
        MyApp.menu.openSubmenu();
    }

    if ($('.js-home-hero-slider__list').length) {
        MyApp.home.heroSlider();        
    }

    if ($('.js-home-hero-links__link').length) {
        MyApp.home.openQuickLinks();
        MyApp.home.closeQuickLinks();        
    }
    if ($('.js-home-features-section__read-more').length) {
        MyApp.home.readMoreFeatures();
    }

    if ($('.js-faqs__question').length) {
        MyApp.faqs.faqsCollapsable();
    }

    if ($('.js-page-team-toggle').length) {
        MyApp.team.teamSlideToggle();
    }

    if ($('.js-contact-form').length) {
        MyApp.contact.form(); 
    }

    if ($('.claims-form').length) {
        MyApp.claims.form();
    }

    if ($('[data-dependand]').length) {
        MyApp.claims.dependand();
    }

    if ($('[name=addPassenger1]')) {
        MyApp.claims.addPassenger1();
    }

    if ($('[name=addPassenger2]')) {
        MyApp.claims.addPassenger2();
    }

    if ($('[name=addProperty]')) {
        MyApp.claims.property();
    }

    if ($('.claims-form__file-button').length) {
        MyApp.claims.file();
    }

    if ($('.phone-mask').length) {
        MyApp.contact.phone(); 
    }

    if ($('.js-page-testimonies-slider').length) {
        MyApp.insurance.testimoniesSlider(); 
    }

    if ($('.js-page-states-content__drop-button').length) {
        MyApp.insurance.stateDroppable(); 
    }

    if ($('.js-page-states__select').length) {
        MyApp.insurance.stateSelect(); 
    }

    if ($('.map-state').length) {
        MyApp.insurance.selectStateMap(); 
    }

    if ($('.js-kc-suscribe__form').length) {
        MyApp.knowledgeCenter.suscribeForm();
    }

    if ($('.js-article-suscribe-form').length) {
        MyApp.article.suscribeForm();
    }
    if ($('.table').length) {
        MyApp.table.responsiveTable();
    }

    if ($('.js-location-form').length) {
        MyApp.locations.locationForm();
    }

    if ($('.js-office-form').length) {
        MyApp.officeProfile.officeProForm();
    }

    if ($('.office__testimonial-slick').length) {
        MyApp.office.testimonials();
    }

    if ($('.dinamycTabs').length) {
        MyApp.dymanicTabs.showTab();
    }

    if ($('button[class*="submit"]').length) {
        MyApp.onPageShow.buttonDisabled();
    }
});

class OsanoTrigger {
    constructor(trigger) {
        this.trigger = trigger;
        this.trigger.addEventListener('click', this.openModal)
    }

    openModal(event) {
        event.preventDefault();
        Osano.cm.showDoNotSell();
        const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
        closeButtonDialog?.focus();
    }
};

window.addEventListener('load', () => {
    document.querySelectorAll('.js-osano-trigger').forEach(link => new OsanoTrigger(link));
});